import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {SecurityContext} from './security-context';
import {RepositoryKey} from '../mt-repository/repository-key';
import {RepositoryType} from '../mt-repository/repository';
import {ApplicationRepository} from '../mt-repository/application-repository';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
    private router = inject(Router);
    private securityContext = inject(SecurityContext);
    private applicationRepository = inject(ApplicationRepository);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.securityContext.isAuthenticated()) {
            return true;
        }
        this.applicationRepository.setItem(RepositoryKey.LAST_SEEN_PAGE, state.url, RepositoryType.LOCAL)
        this.router.navigate(['/login']);
        return false;
    }

}
